module.exports = __webpack_public_path__ + "img/email-confirmed-illustration.28d6363e.svg";